import React from 'react';
import { RadarLegendRing } from './RadarLegendRing.esm.js';
import { getSegment } from './utils.esm.js';

const RadarLegendQuadrant = ({
  segments,
  quadrant,
  rings,
  classes,
  onEntryMouseEnter,
  onEntryMouseLeave
}) => {
  return /* @__PURE__ */ React.createElement(
    "foreignObject",
    {
      key: quadrant.id,
      x: quadrant.legendX,
      y: quadrant.legendY,
      width: quadrant.legendWidth,
      height: quadrant.legendHeight,
      "data-testid": "radar-quadrant"
    },
    /* @__PURE__ */ React.createElement("div", { className: classes.quadrant }, /* @__PURE__ */ React.createElement("h2", { className: classes.quadrantHeading }, quadrant.name), /* @__PURE__ */ React.createElement("div", { className: classes.rings }, rings.map((ring) => /* @__PURE__ */ React.createElement(
      RadarLegendRing,
      {
        key: ring.id,
        ring,
        classes,
        entries: getSegment(segments, quadrant, ring),
        onEntryMouseEnter,
        onEntryMouseLeave
      }
    ))))
  );
};

export { RadarLegendQuadrant };
//# sourceMappingURL=RadarLegendQuadrant.esm.js.map
